import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  videoUrl: string = 'https://api.univ-paris8.fr/media/public_uploads/archivage/tuto_archives_v2.mp4';
  constructor(public dialogRef: MatDialogRef<VideoModalComponent>) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.autoPlayVideo();
  }

  closeModal(): void {
    this.dialogRef.close();
  }


  autoPlayVideo(): void {
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      const video = this.videoPlayer.nativeElement;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          console.log('Video is auto-playing');
        }).catch((error) => {
          console.log('Auto-play prevented:', error);
        });
      }
    }
  }
}
